/**
 * Created by jimmy on 2/3/15.
 */

angular.module('qkr').controller('rnaController', ($scope, appConfig, $rootScope, $routeParams, $routeSegment,
                                                   $sce, rnaService) => {
    $scope.$routeSegment = $routeSegment;
    $scope.pageName = $routeParams.pageName;
    let merchantIdParam = '';
    if ($rootScope.merchantInfo) {
        merchantIdParam = '&merchantId=' + $rootScope.merchantInfo.id;
    }
    $scope.rnaUrl = $sce.trustAsResourceUrl(appConfig.pathPrefix + '/rna/redirectUrl?pageName='
        + $scope.pageName + merchantIdParam);

    // Init
    $scope.init = function() {
        $scope.displayAnalytics = false
        rnaService.getRnaConfig().then(function(response){
            var data = response.data;
            $scope.displayAnalytics = data.displayAnalytics;
            $scope.disableWording = data.disableWording;
        });
    };
});



// WEBPACK FOOTER //
// ./src/controllers/rna.controller.js